import { Chip, makeStyles } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import EuroIcon from "@material-ui/icons/Euro";
import LockIcon from "@material-ui/icons/Lock";
import { get } from "lodash";
import React, { useState } from "react";
import { NumberField } from "react-admin";
import EditDialog from "../dialogs/EditDialog";

const useStyles = makeStyles({
	chip: {
		color: "white",
		"& *": {
			color: "white",
		},
	},
});

const AmountField = ({ source, record, onEditClick }) => {
	const classes = useStyles();
	const [edit, setEdit] = useState(false);
	const isApproved = get(record, "is_approved");
	var formatter = new Intl.NumberFormat("it-IT", {
		style: "currency",
		currency: "EUR",
		useGrouping: true,
	});
	const value = parseFloat(get(record, source));
	const isTotal = get(record, "is_total");
	const handleEdit = () => !isApproved && setEdit(true);

	if (isTotal) {
		return (
			<NumberField
				record={record}
				source={source}
				locales="it-IT"
				options={{ style: "currency", currency: "EUR" }}
				style={{ fontWeight: "bold" }}
				variant="subtitle1"
			/>
		);
	}

	return (
		<>
			<Chip
				className={classes.chip}
				icon={<EuroIcon />}
				label={formatter.format(value)}
				clickable
				color="primary"
				onDelete={handleEdit}
				deleteIcon={isApproved ? <LockIcon /> : <EditIcon />}
			/>
			{edit && (
				<EditDialog userPayment={record} onClose={() => setEdit(false)} />
			)}
		</>
	);
};

export default AmountField;
